import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../../App.css";
import "./Navigation.css";
import SideNavigation from "./SideNavigation";
import TopNavigation from "./TopNavigation";
import Footer from "./Footer";
import Routes from "./Routes";
import { cancelPendingRequests } from "../utils/requestCancellation";

const routeMeta = {
  "/dashboard": ["Operations Overview", "Ringkasan aktivitas lintas platform dan transaksi"],
  "/merchant": ["Merchant", "Kelola informasi dan admin fee merchant"],
  "/merchant/performance": ["Performa Merchant", "Analisis omzet dan kualitas transaksi merchant"],
  "/audit-log": ["Audit Log", "Riwayat aktivitas administrator dan perubahan data"],
  "/cekgudang/companies": ["Daftar Company", "Company yang terdaftar pada ekosistem Cek Gudang"],
  "/transaction": ["Daftar Transaksi", "Pantau invoice dan status pembayaran"],
  "/reportinvoice": ["Laporan Invoice", "Analisis dan rekap invoice"],
  "/reportinvoicefull": ["Laporan Invoice Lengkap", "Detail seluruh aktivitas invoice"],
  "/refund": ["Refund", "Kelola transaksi pengembalian dana"],
  "/checkpayout": ["Pemeriksaan Payout", "Tinjau permintaan pencairan dana"],
  "/approvepayout": ["Persetujuan Payout", "Proses persetujuan pencairan dana"],
  "/reportpayout": ["Laporan Payout", "Rekap aktivitas pencairan dana"],
  "/reportpembayaran": ["Laporan Pembayaran", "Pantau laporan pembayaran"],
  "/calendar": ["Kalender", "Jadwal aktivitas operasional terintegrasi"],
};

class RoutesWithNavigation extends Component {
  state = {
    windowWidth: window.innerWidth,
    sideNavOpen: false,
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.unlistenHistory = this.props.history.listen(() => {
      cancelPendingRequests();
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname && this.state.sideNavOpen) {
      this.setState({ sideNavOpen: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    if (this.unlistenHistory) this.unlistenHistory();
    cancelPendingRequests("SPIN Management Portal ditutup.");
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  toggleSideNav = () => {
    this.setState(currentState => ({ sideNavOpen: !currentState.sideNavOpen }));
  };

  closeSideNav = () => {
    this.setState({ sideNavOpen: false });
  };

  getRouteMeta = () => {
    const { pathname } = this.props.location;

    if (pathname.indexOf("/transactiondetail/") === 0) {
      return ["Detail Invoice", "Informasi lengkap transaksi dan pembayaran"];
    }

    return routeMeta[pathname] || ["Management Portal", "Unified administration workspace"];
  };

  render() {
    const isMobile = this.state.windowWidth < 1000;
    const [routeName, routeDescription] = this.getRouteMeta();

    return (
      <div className="admin-shell">
        <SideNavigation
          isMobile={isMobile}
          isOpen={!isMobile || this.state.sideNavOpen}
          onLinkClick={this.closeSideNav}
          onClose={this.closeSideNav}
        />
        <div className="admin-shell__content">
          <TopNavigation
            routeName={routeName}
            routeDescription={routeDescription}
            onSideNavToggleClick={this.toggleSideNav}
          />
          <main className="admin-main">
            <Routes />
          </main>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(RoutesWithNavigation);
